export const styles = {
  companyManagerHeader: {
    textShadow: '1px 1px navy',
  },
  companyManagersHeader: {
    textShadow: '0px 1px navy',
  },
  projectCoordinatorHeader: {
    fontSize: 18,
    fontWeight: 400,
    marginBottom: 12,
    marginTop: 8,
  },
  projectHeader: {
    fontSize: 18,
    fontWeight: 600,
    marginTop: 35,
    textDecoration: 'underline',
    textDecorationColor: '#F2C94C',
  },
  projectsHeader: {
    marginBottom: -15,
    marginTop: 30,
    textShadow: '0px 1px navy',
  },
}
